import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as QuestionAnswerDAO from '../dao/QuestionAnswerDAO';

export const fetchQuestionAnswers = createAsyncThunk(
  'questionAnswers/fetch',
  async ({ entityName, typeId, recordId }) => {
    return await QuestionAnswerDAO.getQuestionAnswers( entityName,  typeId,  recordId );
  }
);

const questionAnswersSlice = createSlice({
  name: 'questionAnswers',
  initialState: {},
  reducers: {
    updateAnswer: (state, action) => {
      const { entityName, typeId, recordId, cacheKey, questionId, answerValue } = action.payload;
      const answers = state?.[entityName]?.[typeId]?.[recordId]?.[cacheKey];
      if (answers) {
        const answerIndex = answers.findIndex(a => a.questionId === questionId);
        if (answerIndex !== -1) {
          answers[answerIndex].answer = answerValue;
        }
        else {
          console.warn(`Answer for questionId ${questionId} not found in cacheKey ${cacheKey}`);
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchQuestionAnswers.fulfilled, (state, action) => {
      const { entityName, typeId, recordId, cacheKey } = action.meta.arg;
      const answers = action?.payload;
      
      if (!state[entityName]) state[entityName] = {};
      if (!state[entityName][typeId]) state[entityName][typeId] = {};
      if (!state[entityName][typeId][recordId]) state[entityName][typeId][recordId] = {};
      
      state[entityName][typeId][recordId][cacheKey] = answers;
    });
  }
});

export const selectQuestionAnswers = (state, entityName, typeId, recordId, cacheKey) => 
  state.questionAnswers?.[entityName]?.[typeId]?.[recordId]?.[cacheKey];

export const getQuestionAnswers = (entityName, typeId, recordId, cacheKey) => 
  (dispatch, getState) => {
    const answers = selectQuestionAnswers( getState(),  entityName,  typeId,  recordId,  cacheKey );
    
    if (!answers) {
      return dispatch(fetchQuestionAnswers({ entityName,  typeId,  recordId,  cacheKey  }));
    }
    
    return Promise.resolve(answers);
  };

export const { updateAnswer } = questionAnswersSlice.actions;
export default questionAnswersSlice.reducer;
